/**
 * @component {"type":"FeedbackSettings","version":"1.0"}
 * @component {"type":"PageSettings","version":"1.1"}
 * @component {"type":"TemplateSettings","version":"1.0"}
 * @component {"type":"CustomComponent","version":"1.0"}
 * @component {"type":"CustomComponent2","version":"1.0"}
 * @component {"type":"CustomBgImages","version":"1.0"}
 * @component {"type":"GuideBubbles","version":"1.0"}
 */

define('layout',['jquery', 'knockout', 'compiled/custom-templates', 'helpers', 'utils', 'contentLayout', 'contentPreload', 'contentUtils', 'training', 'layout-mobile', 'tooltip'], function($, ko, templates, helpers, utils, ContentLayout, ContentPreload, ContentUtils, Training, LayoutMobile, Tooltip) {
    'use strict';

    return function (viewModel, dataContext) {
        var self = this,
            entityVM = viewModel.entity,
            training = new Training(),
            trainingData,
            contentUtils = new ContentUtils({
                delay: dataContext.expandDelay,
                mobile: dataContext.mobile
            }),
            tooltip = new Tooltip(),
            previousID;

        // var store = Store.default;
            // moduleSVG = svg.default;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        trainingData = dataContext.learning.training;

        self.isFixed = ko.observable(false);

        /* TMP while trainingVM after layoutVM in VM */
        self.trainingComponentsJSON = ko.computed(function () {
            var componentsJson = trainingData.componentsJson;

            return (componentsJson) ? JSON.parse(componentsJson) : [];
        });
        /* TMP END while trainingVM after layoutVM in VM */

        // self.bgImages = helpers.component.getContent(self.trainingComponentsJSON(), 'CustomBgImages');
        self.trainingCategories = ko.observableArray(trainingData.trainingCategories);
        self.trainingCategory = ko.computed(function () {
            var i = 0,
                str = '',
                arr = self.trainingCategories(),
                len = arr.length;

            for (; i < len; i++) {
                str += ' ' + arr[i];
            }

            return str;
        });

        self.trainingTitle = ko.computed(function () {
            var title = trainingData.title || trainingData.name;

            document.title = title;

            return title;
        });

        self.descriptionIsLast = ko.computed(function () {
            var entityContent = entityVM.entityContent(),
                entity = training.getEntity(entityContent.ID),
                layout = (entity && entity.contentEntity.layout && entity.contentEntity.layout.templateKey) ? entity.contentEntity.layout : dataContext.layout,
                elements = {};

            if (!entity) {
                return false;
            }

            if(entity.contentEntity.layout.templateKey == "" && entityContent.typeID === 10) return true; // default layout and content page -> body always last

            if (layout.hasOwnProperty('elements') && layout.elements) {
                elements = layout.elements;
            } else {
                if (entityContent.typeID === 20 && dataContext.layout.hasOwnProperty('sortToGroups') && dataContext.layout.sortToGroups) {
                    elements = dataContext.layout.sortToGroups;
                } else if (entityContent.typeID === 10 && dataContext.layout.hasOwnProperty('elementsContentPage') && dataContext.layout.elementsContentPage) {
                    elements = dataContext.layout.elementsContentPage;
                } else {
                    elements = (dataContext.layout.hasOwnProperty('elements') && dataContext.layout.elements) ? dataContext.layout.elements : {};
                }
            }

            return (elements.hasOwnProperty('body') && (elements.body.length == 1 ? (elements.body[0][1] == 3): (elements.body[1][1] == 3)));
        });

        self.comments = ko.computed(function () {
            return dataContext.comments;
        });

        self.pageComponents = ko.observableArray();
        self.setPageComponents = function (str) {
            self.pageComponents.push(str);
        };

        self.getComponentTemplates = function (arr) {
            var res = [],
                obj = {},
                kind = '';

            if (!arr || !Array.isArray(arr)) {
                return res;
            }

            for (var i = 0; i < arr.length; i++) {
                obj = {};

                kind = (arr[i].kind) ? arr[i].kind.toLowerCase() : '';

                switch (arr[i].kind) {
                    case 'Accordion':
                        obj = {key: 'accordion', templateID: 'ko-template-component-accordion'};
                        break;
                    case 'AnswerPopup': // Workbook answers
                        obj = {key: 'answer-popup', templateID: 'ko-template-component-answerpopup'};
                        break;
                    case 'Audio':
                        obj = {key: 'audio', templateID: 'ko-template-component-audio'};
                        break;
                    case 'CustomComponent':
                        obj = {key: 'custom-component', templateID: 'ko-template-component-custom-component'};
                        break;
                    case 'CustomComponent2':
                        obj = {key: 'custom-component-2', templateID: 'ko-template-component-custom-component-2'};
                        break;
                    case 'DiplomaButton':
                        obj = {key: 'diploma-button', templateID: 'ko-template-component-diploma-button'};
                        break;
                    case 'EdgeComponent':
                        obj = {key: 'edge-component', templateID: 'ko-template-component-edge-component'};
                        break;
                    case 'ExtraInfoContent':
                        obj = {key: 'extra-info-content', templateID: 'ko-template-component-extra-info-content'};
                        break;
                    case 'ExtraInfoLauncher':
                        obj = {key: 'extra-info-launcher', templateID: 'ko-template-component-extra-info-launcher'};
                        break;
                    case 'FlipCards':
                        obj = {key: 'flip-cards', templateID: 'ko-template-component-flip-cards'};
                        break;
                    case 'Hotspots':
                        obj = {key: 'hotspots', templateID: 'ko-template-component-hotspots'};
                        break;
                    case 'Leaderboard':
                        obj = {key: 'leaderboard', templateID: 'ko-template-component-leaderboard'};
                        break;
                    case 'ModularNavigation':
                        obj = {key: 'modular-navigation', templateID: 'ko-template-component-modular-navigation'};
                        break;
                    case 'QuizGame':
                        obj = {key: 'quiz-game', templateID: 'ko-template-component-quiz-game'};
                        break;
                    case 'SecondColumnContent':
                        obj = {key: 'second-column', templateID: 'ko-template-component-second-column'};
                        break;
                    case 'SectionComponent':
                        obj = {key: 'section-component', templateID: 'ko-template-component-section-component'};
                        break;
                    case 'SlideShow':
                        obj = {key: 'slide-show', templateID: 'ko-template-component-slide-show'};
                        break;
                    case 'Statistics':
                        obj = {key: 'statistics', templateID: 'ko-template-component-statistics'};
                        break;
                    case 'SuperButton':
                        obj = {key: 'super-button', templateID: 'ko-template-component-super-button'};
                        break;
                    case 'Tabs':
                        obj = {key: 'tabs', templateID: 'ko-template-component-tabs'};
                        break;
                    case 'TextsOnImage':
                        obj = {key: 'texts-on-image', templateID: 'ko-template-component-texts-on-image'};
                        break;
                    case 'Video':
                        obj = {key: 'video', templateID: 'ko-template-component-video'};
                        break;
                    default:
                        obj = {key: kind, templateID: ''};
                }

                obj.kind = kind;
                obj.content = arr[i];

                res.push(obj);
            }

            return res;
        }

        self.componentTemplates = ko.computed(function () {
            return self.getComponentTemplates(entityVM.componentsJSON());
        });

        self.singleColumn = ko.observable(false);
        self.feedbackClass = ko.observable('');

        self.bodyClassPrefix = ko.computed(function () {
            var layout = (dataContext.hasOwnProperty('layout') && dataContext.layout && typeof dataContext.layout === 'object') ? dataContext.layout : null,
                type = (layout && layout.hasOwnProperty('type') && layout.type) ? layout.type : 'default',
                // width = (layout && layout.hasOwnProperty('width') && layout.width) ? layout.width : 1180,
                // height = (layout && layout.hasOwnProperty('height') && layout.height) ? layout.height : 720,
                isFixed = (type === 'fixed') ? true : false,
                res = (dataContext.transition === 'css') ? 'css-transition' : '';

            self.isFixed(isFixed);

            switch (type) {

                case 'fixed':
                    var tag = document.querySelector('meta[name="viewport"]');

                    res += ' fixed-layout';

                    if (tag) {
                        tag.setAttribute('content', 'width=device-width, initial-scale=1, user-scalable=yes');
                    }

                    break;
                default:
                    res += ' default-layout';

                    break;
            }

            if (dataContext.landscape) {
                res += ' landscape-only';
            }

            return res;
        });

        self.staticBodyClasses = ko.observableArray();  // This can be used to added body classes that affect entire course
                                                        // Used from Modular Menu, Footer Timeline

        self.bodyClass = ko.computed(function () {
            var bodyClass = '',
                entityContent = entityVM.entityContent(),
                entity = training.getEntity(entityContent.ID),

                trainingPageSettings = helpers.component.getContent(self.trainingComponentsJSON(), 'PageSettings'),
                trainingFeedbackSettings = helpers.component.getContent(self.trainingComponentsJSON(), 'FeedbackSettings'),

                // Backwards compatibility
                layoutSettings = helpers.component.getContent(entityContent.componentsJSON, 'LayoutSettings'),
                // END Backwards compatibility

                entityPageSettings = helpers.component.getContent(entityContent.componentsJSON, 'PageSettings'),
                entityFeedbackSettings = helpers.component.getContent(entityContent.componentsJSON, 'FeedbackSettings'),

                feedback = {
                    horizontal: 'feedback-pos-right',
                    vertical: 'feedback-pos-bottom'
                },
                layout = (entity && entity.contentEntity.layout) ? entity.contentEntity.layout : dataContext.layout,
                template = (layout.hasOwnProperty('templateKey') && layout.templateKey) ? layout.templateKey.toLowerCase() : '',
                singleColumn = false;

            if (Object.keys(entityPageSettings).length) {

                bodyClass += (entityPageSettings.bodyClass) ? ' ' + entityPageSettings.bodyClass : '';
                bodyClass += (entityPageSettings.customBodyClass) ? ' ' + entityPageSettings.customBodyClass : '';

                if (entityPageSettings.bodyClass === 'single-column-layout') {
                    singleColumn = true;
                }

                // Backwards compatibility
            } else if (Object.keys(layoutSettings).length) {

                bodyClass += (layoutSettings.bodyClass) ? ' ' + layoutSettings.bodyClass : '';
                bodyClass += (layoutSettings.customBodyClass) ? ' ' + layoutSettings.customBodyClass : '';

                if (layoutSettings.bodyClass === 'single-column-layout') {
                    singleColumn = true;
                }
                // END Backwards compatibility
            } else if (Object.keys(trainingPageSettings).length) {

                bodyClass += trainingPageSettings.bodyClass ? ' ' + trainingPageSettings.bodyClass : '';
                bodyClass += trainingPageSettings.customBodyClass ? ' ' + trainingPageSettings.customBodyClass : '';

                if (trainingPageSettings.bodyClass === 'single-column-layout') {
                    singleColumn = true;
                }

            }

            if (training.modularMenuPage.ID) {
                bodyClass += ' modular-navigation';

                if (training.modularMenuPage.hideToc) {
                    bodyClass += ' hide-nav-menu';
                }
            }

            bodyClass += ' '+ self.staticBodyClasses().join(' ');

            if (entityVM.isQuizGame()) {
                bodyClass += ' layout-quiz-game';

                if (viewModel.quizGame) {
                    bodyClass += ' ' + viewModel.quizGame.phaseClass();
                }
            }

            switch (template) {
                case 'taskonright':

                    feedback.horizontal = 'feedback-pos-left';

                    break;
                case 'taskatbottom':

                    feedback.horizontal = 'feedback-pos-right';
                    feedback.vertical = 'feedback-pos-top';

                    break;
                case 'largecomponent':

                    bodyClass += (Object.keys(helpers.component.getContent(entityContent.componentsJSON, 'Video')).length) ? ' layout-custom-main' : '';
                    bodyClass += (Object.keys(helpers.component.getContent(entityContent.componentsJSON, 'FlipCards')).length) ? ' layout-visible-main' : '';

                    break;
            }

            if (self.singleColumn() || singleColumn) {

                bodyClass += ' single-column-layout';
                feedback.horizontal = 'feedback-single-column';

            } else {
                if (Object.keys(entityFeedbackSettings).length) {
                    if (entityFeedbackSettings.hasOwnProperty('horizontal') && entityFeedbackSettings.horizontal) {
                        feedback.horizontal = entityFeedbackSettings.horizontal;
                    }
                } else if (Object.keys(trainingFeedbackSettings).length) {
                    if (trainingFeedbackSettings.hasOwnProperty('horizontal') && trainingFeedbackSettings.horizontal) {
                        feedback.horizontal = trainingFeedbackSettings.horizontal;
                    }
                }
            }

            if (Object.keys(entityFeedbackSettings).length) {
                if (entityFeedbackSettings.hasOwnProperty('vertical') && entityFeedbackSettings.vertical) {
                    feedback.vertical = entityFeedbackSettings.vertical;
                }
            } else if (Object.keys(trainingFeedbackSettings).length) {
                if (trainingFeedbackSettings.hasOwnProperty('vertical') && trainingFeedbackSettings.vertical) {
                    feedback.vertical = trainingFeedbackSettings.vertical;
                }
            }

            if (entityVM.showTextAreaBackground()) {
                bodyClass += ' body-background';
            }

            self.feedbackClass(feedback.horizontal + ' ' + feedback.vertical);

            return self.bodyClassPrefix() + bodyClass;
        }).extend({'rateLimit': 0});


        self.applyBindings = function () {
            document.querySelectorAll('.js-append-bindings, .js-append-bindings svg').forEach(function(node) {
                try {
                    // ko.cleanNode(node);
                    ko.applyBindingsToDescendants(viewModel, node);
                } catch (e) {
                    if (dataContext.debugMode) {
                        console.dir(e);
                    }
                }
            });

            setTimeout(function(){
                setGPTooltips();
                setupGuideBubbles();
            }, 0);
        };

        // this is mainly for backwards compatibility, to be removed
        function setGPTooltips() {
            tooltip.setGPTooltips(viewModel.training);
        }

        function setupGuideBubbles() {
            var entityContent = entityVM.entityContent(),
                guideBubbleComponent = helpers.component.getContent(entityContent.componentsJSON, 'GuideBubbles'),
                guideBubbleItems = helpers.component.parseProp(guideBubbleComponent, 'items', 'GuideBubbleItem');

            if (guideBubbleItems.length) {
                for (var i=0;i<guideBubbleItems.length;i++) {
                    var gbItem = guideBubbleItems[i];
                    tooltip.setupGuideBubble(gbItem);
                }
            }
        }

        function setPlayerBgImage(ID) {
            var player = document.getElementById('player'),
                playerBgImage = document.getElementById('custom-bg-images'),
                bgImage = trainingData.player.backgroundImageId,
                imageUrl,
                imageId,
                content = helpers.component.getContent(training.componentsJSON, 'CustomBgImages'),
                bgImages = helpers.component.parseProp(content, 'items', 'CustomBgImageItem');

            if (!player || (!bgImage && !bgImages.length)) {
                return;
            }

            bgImages.forEach(function(a) {
                if (helpers.entity.isInPageRange(training.contentEntities, ID, a.startPage, a.endPage)) {
                    imageId = a.image;
                }
            });

            imageUrl = imageId ? training.parseMediaURL(imageId) : training.getMediaURL(bgImage);

            // Create DOM nodes for background image holders
            if (!playerBgImage) {
                playerBgImage = document.createElement("div");
                playerBgImage.id = 'custom-bg-images';

                var bgHolder1 = document.createElement("div"),
                    bgHolder2 = document.createElement("div");

                bgHolder2.classList.add("active");
                playerBgImage.appendChild(bgHolder1);
                playerBgImage.appendChild(bgHolder2);

                player.insertBefore(playerBgImage, player.childNodes[0]);
            }

            var newVal = (imageUrl ? 'url("' + imageUrl + '")' : 'none'),
                activeHolder = document.querySelector('#custom-bg-images .active'),
                inactiveHolder = document.querySelector('#custom-bg-images :not(.active)');

            if (activeHolder.style.backgroundImage != newVal) {  // Change if not the same
                if (newVal !== 'none') {
                    //preload image first
                    var bgImg = new Image();
                    bgImg.onload = function(){
                        inactiveHolder.style.backgroundImage = newVal;
                        inactiveHolder.classList.add('active');
                        activeHolder.classList.remove('active');
                    };
                    bgImg.src = imageUrl;
                } else {
                    inactiveHolder.style.backgroundImage = 'none';
                    inactiveHolder.classList.add('active');
                    activeHolder.classList.remove('active');
                }
            }
        }

        ko.bindingHandlers.contentPrepend = {
            init: function () {
                var player = document.getElementById('player'),
                    color = trainingData.player.backgroundColor;

                if(player && color && player.style.backgroundColor != color) {
                    player.style.backgroundColor = color;
                }

                helpers.layout.appendContent({
                    type: 'css',
                    content: trainingData.customCss
                });

                helpers.layout.appendContent({
                    ID: 'custom-templates',
                    containerID: 'ko-templates-prepend',
                    content: templates
                });

                helpers.layout.appendContent({
                    ID: 'custom-ui-templates',
                    containerID: 'ko-templates-prepend',
                    content: trainingData.customUiTemplates
                });

                return {
                    controlsDescendantBindings: true
                };
            },
            update: function () {
                var start = new Date(),
                    entityContent = entityVM.entityContent(),
                    ID = entityContent.ID;

                if (dataContext.debugMode) {
                    console.log('--------- until layoutVM bindings: ' + (new Date() - window.initPageRender) + '  ---------');
                }

                // Remove non permanent (course specific) tooltips
                var tooltips = document.querySelectorAll('.qtip:not(.permanent-tip)'),
                    gpTooltips = document.querySelectorAll('.gptooltip');

                Array.prototype.forEach.call( tooltips, function( node ) {
                    node.parentNode.removeChild( node );
                });

                Array.prototype.forEach.call( gpTooltips , function( node ) {
                    $(node).remove();
                });

                if (dataContext.expandable && !self.isFixed() && previousID !== ID) {
                    contentUtils.shrinkContent();
                }

                previousID = ID;

                setPlayerBgImage(ID);

                helpers.layout.appendContent({
                    ID: 'custom-css',
                    type: 'css',
                    content: entityContent.customCSS + entityContent.componentCSS + entityContent.componentCSS2
                });

                helpers.layout.appendContent({
                    ID: 'custom-html',
                    containerID: 'ko-templates',
                    content: entityContent.customHTML
                });

                entityVM.componentHTML(entityContent.componentHTML);
                entityVM.componentHTML2(entityContent.componentHTML2);

                if (dataContext.mobile.enabled && !self.isFixed()) {
                    var layoutMobile = new LayoutMobile();
                    layoutMobile.destroy();
                }

                if (dataContext.debugMode) {
                    console.log('1. contentPrepend (duration: ' + (new Date() - start) + ')');
                }

            }
        };

        ko.bindingHandlers.contentLayout = {
            init: function () {
                return {
                    controlsDescendantBindings: true
                };
            },
            update: function (container, valueAccessor, allBindings, viewModel, bindingContext) {
                var start = new Date(),
                    contentLayout = null,
                    entityContent = entityVM.entityContent(),
                    entity = training.getEntity(entityContent.ID),
                    componentsJSON = entityContent.componentsJSON,

                    // Backwards compatibility
                    layoutSettings = helpers.component.getContent(componentsJSON, 'LayoutSettings'),
                    // END Backwards compatibility

                    trainingPageSettings = helpers.component.getContent(self.trainingComponentsJSON(), 'PageSettings'),
                    entityPageSettings = helpers.component.getContent(componentsJSON, 'PageSettings'),

                    // Backwards compatibility
                    separationLine = !!layoutSettings.separationLine,

                    contentPosition = layoutSettings.contentPosition,
                    contentPositionAside = layoutSettings.contentPositionAside,
                    // END Backwards compatibility

                    contentPositionHorizontal,
                    contentPositionAsideHorizontal,

                    singleColumn = (layoutSettings.bodyClass === 'single-column-layout') ? true :false;

                if (Object.keys(entityPageSettings).length) {
                    separationLine = !!entityPageSettings.separationLine;

                    if (entityPageSettings.bodyClass === 'single-column-layout') {
                        singleColumn = true;
                    }

                    contentPositionHorizontal = entityPageSettings.contentPositionHorizontal;
                    contentPosition = entityPageSettings.contentPosition;
                    contentPositionAsideHorizontal = entityPageSettings.contentPositionAsideHorizontal;
                    contentPositionAside = entityPageSettings.contentPositionAside;

                } else if (Object.keys(trainingPageSettings).length) {
                    separationLine = !!trainingPageSettings.separationLine;

                    if (trainingPageSettings.bodyClass === 'single-column-layout') {
                        singleColumn = true;
                    }

                    contentPositionHorizontal = entityPageSettings.contentPositionHorizontal;
                    contentPosition = trainingPageSettings.contentPosition;
                    contentPositionAsideHorizontal = entityPageSettings.contentPositionAsideHorizontal;
                    contentPositionAside = trainingPageSettings.contentPositionAside;
                }

                if (!entity) {
                    return;
                }

                container.innerHTML = '';
                // ko.virtualElements.emptyNode(container);

                self.pageComponents.removeAll();

                var layout = (entity.contentEntity.layout) ? entity.contentEntity.layout : dataContext.layout,
                    elements = {},
                    template = (layout.hasOwnProperty('templateKey')) ? layout.templateKey : '',
                    alignment = {
                        horizontal: {
                            aside: contentPositionAsideHorizontal,
                            content: contentPositionHorizontal
                        },
                        vertical: {
                            aside: contentPositionAside,
                            content: contentPosition
                        }

                    },
                    updateElements = function(layoutElements, componentsJSON, template, singleColumn) {
                        var content,
                            elements = helpers.misc.cloneObject(layoutElements);

                        if (singleColumn) {
                            return elements;
                        }

                        content = helpers.component.getContent(componentsJSON, 'Statistics');

                        if (!content || !Object.keys(content).length) {
                            return elements;
                        }

                        if (template === '' || template === 'TaskOnLeft') {
                            if (elements.componentdefault) {
                                elements.componentdefault = [[2, 3]];
                            } else if (elements.componentDefault) {
                                elements.componentDefault = [[2, 3]];
                            }
                        } else if (template === 'TaskOnRight') {
                            elements.task = [[2, 3]];
                        }

                        return elements;
                    },
                    mobile = (dataContext.layout) ? helpers.misc.cloneObject(dataContext.layout.mobile) : {};

                if (layout.mobile) {
                    if (layout.mobile.order) {
                        mobile.order = layout.mobile.order;
                    }
                    if (layout.mobile.fixed) {
                        mobile.fixed = layout.mobile.fixed;
                    }
                    if (layout.mobile.hidden) {
                        mobile.hidden = layout.mobile.hidden;
                    }
                }

                if (layout.hasOwnProperty('elements') && layout.elements) {
                    elements = layout.elements;
                } else {
                    if (entityContent.typeID === 20 && dataContext.layout.hasOwnProperty('sortToGroups') && dataContext.layout.sortToGroups) {
                        elements = dataContext.layout.sortToGroups;
                    } else if (entityContent.typeID === 16 && dataContext.layout.hasOwnProperty('matchPairs') && dataContext.layout.matchPairs) {
                        elements = dataContext.layout.matchPairs;
                    } else if (entityContent.typeID === 10 && dataContext.layout.hasOwnProperty('elementsContentPage') && dataContext.layout.elementsContentPage) {
                        elements = dataContext.layout.elementsContentPage;
                    } else {
                        elements = (dataContext.layout.hasOwnProperty('elements') && dataContext.layout.elements) ? dataContext.layout.elements : {};
                    }
                }

                if (entityContent.typeID === 14 || entityContent.typeID === 13 && entityContent.displayMode === 3) {
                    elements = updateElements(elements, componentsJSON, template, singleColumn);
                }

                contentLayout = new ContentLayout({
                    alignment: alignment,
                    container: container,
                    component: (Array.isArray(componentsJSON) && componentsJSON.length > 0) ? true : false,
                    layoutElements: elements,
                    layoutTemplate: template,
                    imageURL: entityContent.imageURL,
                    layoutWidth: (layout.hasOwnProperty('columnWidthAdjustment')) ? layout.columnWidthAdjustment : 0,
                    missing: helpers.layout.isMissing(elements, self.getComponentTemplates(componentsJSON)),
                    singleColumn: singleColumn,
                    separator: separationLine,
                    mobile: mobile
                });

                self.singleColumn(contentLayout.singleColumn);

                ko.applyBindingsToDescendants(bindingContext, container);

                if (dataContext.debugMode) {
                    console.log('2. contentLayout (duration: ' + (new Date() - start) + ')');
                    console.dir(contentLayout);
                }
            },
            after: ['contentPrepend']
        };

        ko.bindingHandlers.contentAppend = {
            init: function () {
                var flexboxDisown = !Modernizr.flexbox && !Modernizr.flexboxlegacy && !Modernizr.flexboxtweener && !utils.isTouchDevice,
                    expandable = dataContext.expandable && !self.isFixed();

                helpers.layout.appendContent({
                    type: 'js',
                    content: trainingData.customJavascript
                });

                if (flexboxDisown && expandable) {
                    window.addEventListener('resize', function () {
                        contentUtils.updateProperties();
                        contentUtils.resizeContent();
                        contentUtils.imitateFlexbox();
                    }, false);
                } else if (expandable) {
                    window.addEventListener('resize', function () {
                        contentUtils.updateProperties();
                        contentUtils.resizeContent();
                    }, false);
                } else if (flexboxDisown) {
                    window.addEventListener('resize', function () {
                        contentUtils.updateProperties();
                        contentUtils.imitateFlexbox();
                    }, false);
                }

                return {
                    controlsDescendantBindings: true
                };
            },
            update: function () {
                var start = new Date(),
                    entityContent = entityVM.entityContent(),
                    delay = dataContext.preloadDelay || 0,
                    contentAppend = function() {
                        var contentPreload = function () {
                                new ContentPreload({
                                    entityContent: entityContent,
                                    entities: trainingData.contentEntities,
                                    debugMode: dataContext.debugMode
                                });
                            },
                            strJS = entityContent.componentJS + entityContent.componentJS2 + entityContent.customJS;

                        helpers.layout.prependContent({
                            containerID: 'ko-templates',
                            ID: 'custom-component-js',
                            type: 'js',
                            content: (utils.isOldIE) ? utils.escapeHTML(strJS) : strJS
                        });

                        self.applyBindings();

                        setTimeout(function () {
                            contentPreload();
                        }, delay);

                        if (utils.isBrowserMS()) {
                            contentUtils.touchContent();
                        }
                    },
                    entity = training.getEntity(entityContent.ID),
                    layout = (entity.contentEntity.layout) ? entity.contentEntity.layout : dataContext.layout,
                    mobile = (dataContext.layout) ? helpers.misc.cloneObject(dataContext.layout.mobile) : {};

                require(['svg'], function(module) {
                    var svg = module.default;

                    var h = document.getElementById('js-hotspots-tooltips'),
                        f = document.getElementById('content-figure-svg');

                    if (h && entityContent.hotspotsImageContentType === 'image/svg+xml') {
                        h.style.visibility = 'hidden';
                    }

                    if (f && entityContent.imageContentType === 'image/svg+xml') {
                        f.style.visibility = 'hidden';
                    }

                    Promise.all([
                        svg.loadImage(entityContent.hotspotsImageURL, entityContent.hotspotsImageContentType, 'js-hotspots-tooltips'),
                        svg.loadImage(entityContent.imageURL, entityContent.imageContentType, 'content-figure-svg')
                    ]).then(function() {

                        svg.setSvgTexts('#content-figure-svg, #js-hotspots-tooltips');

                        if (h && entityContent.hotspotsImageContentType === 'image/svg+xml') {
                            h.style.visibility = 'visible';
                        }

                        if (f && entityContent.imageContentType === 'image/svg+xml') {
                            f.style.visibility = 'visible';
                        }

                        svg.updateContentSVG();

                        Promise.all(svg.setImagesSource(entityContent.componentImages)).then(function() {
                            contentAppend();
                        });
                    });

                    svg.setSvgTexts('#player svg');
                });

                if (layout.mobile) {
                    if (layout.mobile.order) {
                        mobile.order = layout.mobile.order;
                    }
                    if (layout.mobile.fixed) {
                        mobile.fixed = layout.mobile.fixed;
                    }
                    if (layout.mobile.hidden) {
                        mobile.hidden = layout.mobile.hidden;
                    }
                }

                if (!Modernizr.flexbox && !Modernizr.flexboxlegacy && !Modernizr.flexboxtweener && !utils.isTouchDevice) {
                    contentUtils.imitateFlexbox();
                }

                if (dataContext.expandable && !self.isFixed()) {
                    contentUtils.resizeContent();
                }

                if (dataContext.mobile.enabled && !self.isFixed()) {
                    var layoutMobile = new LayoutMobile();

                    layoutMobile.setOrder(mobile);

                    layoutMobile.init();
                }

                if (dataContext.debugMode) {
                    console.log('3. contentAppend (duration: ' + (new Date() - start) + ')');
                }
            },
            after: ['contentComponents']
        };

        /**
         * Returns templateID to be used
         * @param {str} section - component's section
         * @param {str} key - key to identify element component
         * @param {str} templateID - default templateID last part
         * @return {str} template string
         */
        self.templateID = function (section, key, templateID) {
            var entityContent = entityVM.entityContent(),
                componentsJSON = entityContent.componentsJSON,
                trainingComponentsJSON = self.trainingComponentsJSON(),
                getTemplateID = function (section, key, arr, settings) {
                    var content = helpers.component.getContent(arr, settings),
                        prop = helpers.component.parseProp(content, section, 'template' + section),
                        obj = helpers.component.parseContent(prop);

                    return (obj && !!obj[key]) ? obj[key] : '';
                };

            if (trainingComponentsJSON.length) {
                templateID = getTemplateID(section, key, trainingComponentsJSON, 'TemplateSettings') || templateID;
            }

            if (componentsJSON && componentsJSON.length) {
                // Backwards compatibility
                templateID = getTemplateID(section, key, componentsJSON, 'LayoutSettings') || templateID;
                // END Backwards compatibility

                templateID = getTemplateID(section, key, componentsJSON, 'TemplateSettings') || templateID;
            }

            if (!templateID || !document.getElementById(templateID)) {

                if (dataContext.debugMode) {
                    console.error('"' + templateID + '" template DOES NOT exist (section: ' + section + ', key: ' + key + ')');
                }
                return 'ko-template-empty';
            }

            return templateID;
        }

    };

});

